import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-cream py-12 border-t-4 border-warm-brown" data-id="element-109" data-mp="32wd2cf6gdjt0">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110" data-mp="3gg11ma61ua0t">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-111" data-mp="32o48q3wk3w3d">
          <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-112" data-mp="36pfs3rou7l34">
            <h2 className="font-serif text-2xl tracking-widest uppercase mb-2" data-id="element-113" data-mp="36pzebklisvmy">
              Freddie Cheah
            </h2>
            <p className="text-gray-400 text-sm tracking-widest uppercase" data-id="element-114" data-mp="3ud7hnwze1umc">
              Asian Fusion
            </p>
          </div>

          <div className="flex space-x-6 mb-6 md:mb-0" data-id="element-115" data-mp="3lf582t1l9tng">
            <a href="#" className="text-gray-400 hover:text-amber transition-colors" data-id="element-116" data-mp="3lggfd2u8tjjb">
              Instagram
            </a>
            <a href="#" className="text-gray-400 hover:text-amber transition-colors" data-id="element-117" data-mp="29ydxc2mb78ay">
              Facebook
            </a>
            <a href="#" className="text-gray-400 hover:text-amber transition-colors" data-id="element-118" data-mp="3l90ntw47myz9">
              Yelp
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-119" data-mp="3v7ggw4mssibe">
          <p data-id="element-120" data-mp="3q7u3nv6yz22l">
            &copy; {new Date().getFullYear()} Freddie Cheah. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-121" data-mp="8178js5jp0n7">Paducah, Kentucky</p>
        </div>
      </div>
    </footer>;
}